import React, { useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
import Dropdown from "react-bootstrap/Dropdown";
import Header from "../dashboard/Header";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import LoginRedirection from "../../Service/LoginRedirection";
import TokenUndefined from "../../Service/TokenUndefined";
import { Button, Spinner } from "react-bootstrap";
import useFetchData from "../../../common/useFetchData";

function AddArea() {
  const [area, setArea] = useState("");
  const [owner, setOwner] = useState("");
  const [staff, setStaff] = useState("");
  const [extra, setExtra] = useState("");
  const [family, setFamily] = useState("");
  const [vipGuest1, setVipGuest1] = useState("");
  const [areaError, setAreaError] = useState("");
  const [ownerError, setOwnerError] = useState("");
  const [staffError, setStaffError] = useState("");
  const [extraError, setExtraError] = useState("");
  const [familyError, setFamilyError] = useState("");
  const [modelError, setModelError] = useState("");
  const [model, setModel] = useState("");
  const [roomsAllowed, setRoomsAllowed] = useState("");
  const [roomsAllowedError, setRoomsAllowedError] = useState("");

  const [vipGuest1Error, setVipGuest1Error] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const array = ["Exhibitor Company", "Exhibitor Agency"];
  const [category_name, setCategory_name] = useState("");
  const { showData, error } = useFetchData();


  const handleSubmit = () => {
    TokenUndefined("  superadmin/login");
    setIsLoading(true);
    if (!area || !String(area).trim()) {
      message.error("Area is Empty");
      setIsLoading(false);
      return;
    }
    if (areaError) {
      message.error(areaError);
      setIsLoading(false);
      return;
    }
    if (!category_name) {
      message.error("Category field is not present");
      setIsLoading(false);
      return;
    }
    if (!owner) {
      message.error("Owner field is not present");
      setIsLoading(false);
      return;
    }
    if (!staff) {
      message.error("Staff field is not present");
      setIsLoading(false);
      return;
    }
    // if (!family) {
    //   message.error("Family field is not present");
    //   setIsLoading(false);
    //   return;
    // }
    // if (!model) {
    //   message.error("model field is not present");
    //   setIsLoading(false);
    //   return;
    // }
    // if (!vipGuest1) {
    //   message.error("VIP Guest 1 field is not present");
    //   setIsLoading(false);
    //   return;
    // }

    axios
      .post(
        `${process.env.REACT_APP_API_END_POINT}/add-area`,
        {
          area,
          owner,
          staff,
          extra,
          family,
          day_one_guest: vipGuest1,
          category_name,
          model,
          rooms_allowed: roomsAllowed
        },
        {
          headers: {
            token: localStorage.getItem("jff_token"),
          },
        }
      )
      .then((res) => {
        LoginRedirection(res, "superadmin/login");
        message.success("Form Submit Successfully");
        navigate("/superadmin/area-list");
        setIsLoading(false);
      })
      .catch((err) => {
        LoginRedirection("/superadmin/login");
        if (err.response.status === 401) {
          navigate("/superadmin/login");
          portalAuth.logoutActive();
        }
      });
  };
  const handleAreaChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9\s\-_./]*$/.test(value)) {
      setArea(value);
      setAreaError("");
    } else {
      setAreaError("Must contain only alphanumeric characters.");
    }
  };

  const handleOwnerChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setOwnerError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setOwner(value);
      setOwnerError("");
    } else {
      setOwnerError("Must contain only numbers.");
    }
  };

  const handleStaffChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setStaffError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setStaff(value);
      setStaffError("");
    } else {
      setStaffError("Must contain only numbers.");
    }
  };

  const handleExtraBadgeChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setExtraError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setExtra(value);
      setExtraError("");
    } else {
      setExtraError("Must contain only numbers.");
    }
  };

  const handleFamilyChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setFamilyError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setFamily(value);
      setFamilyError("");
    } else {
      setFamilyError("Must contain only numbers.");
    }
  };

  const handleModelChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setModelError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setModel(value);
      setModelError("");
    } else {
      setModelError("Must contain only numbers.");
    }
  };


  const handleVipGuest1Change = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setVipGuest1Error("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setVipGuest1(value);
      setVipGuest1Error("");
    } else {
      setVipGuest1Error("Must contain only numbers.");
    }
  };


  useEffect(() => {
    const num = parseFloat(area);
    if (!isNaN(num)) {
      if (num > 400) {
        setCategory_name('Exhibitor Agency');
      } else {
        setCategory_name('Exhibitor Company');
      }
    }
  }, [area]);

  return (
    <>
      <Header />
      {showData && showData.area === "active" ? <div className="container my-2 ">
        <div className="content-height">
          <div className="text-center">
            <h3 className="form-heading">Add Area</h3>
          </div>
          {/* <center> */}
          <div className="form-body-section">
            <div className="form-body">
              <div className="row">
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    Area(Sq Mtrs) <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleAreaChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={area}
                    placeholder="Area"
                    name="area"
                    autocomplete="off"
                  // maxLength={4}
                  />
                  {areaError && (
                    <span style={{ color: "red" }}>{areaError}</span>
                  )}
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    Category <font color="#FF0000">*</font>
                  </label>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="form-control border my-2"
                    >
                      {category_name ? category_name : "Choose Category"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="form-control nodesure"
                    // style={{ overflowY: "scroll", maxHeight: "15vh" }}
                    >
                      {array?.map((item, i) => (
                        <Dropdown.Item
                          key={i}
                          value={item.area}
                          onClick={() => setCategory_name(item)}
                          className="d-flex justify-content-center"
                        >
                          {item}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Owner <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleOwnerChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={owner}
                    placeholder="Owner"
                    name="owner"
                    autocomplete="off"
                    maxLength={3}
                  />
                  {ownerError && (
                    <span style={{ color: "red" }}>{ownerError}</span>
                  )}
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Staff <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleStaffChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={staff}
                    placeholder="Staff"
                    name="staff"
                    autocomplete="off"
                    maxLength={3}
                  />
                  {staffError && (
                    <span style={{ color: "red" }}>{staffError}</span>
                  )}
                </div>
                {/* <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Extra badges allowed <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleExtraBadgeChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={extra}
                    placeholder="Extra Count"
                    name="extra"
                    autocomplete="off"
                    maxLength={3}
                  />
                  {extraError && (
                    <span style={{ color: "red" }}>{extraError}</span>
                  )}
                </div> */}

                {/*<div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Family <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleFamilyChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={family}
                    placeholder="Family"
                    name="family"
                    autocomplete="off"
                    maxLength={3}
                  />
                  {familyError && (
                    <span style={{ color: "red" }}>{familyError}</span>
                  )}
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Model <font color="#FF0000">*</font>
                  </label>
                  <input
                    onChange={handleModelChange}
                    className="form-control my-2"
                    required
                    type="text"
                    value={model}
                    placeholder="Model"
                    name="model"
                    autocomplete="off"
                    maxLength={3}
                  />

                </div> */}


                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">
                    No. of Buyer <font color="#FF0000">*</font>{" "}
                  </label>
                  <input
                    onChange={handleVipGuest1Change}
                    className="form-control my-2"
                    required
                    type="text"
                    value={vipGuest1}
                    placeholder="Buyer"
                    name="vip_day_1"
                    autocomplete="off"
                    maxLength={3}
                  />
                  {vipGuest1Error && (
                    <span style={{ color: "red" }}>{vipGuest1Error}</span>
                  )}
                </div>

                <div className="form-submit">
                  <Button
                    type="submit"
                    style={{ width: "90px" }}
                    value="Submit"
                    name="addArea"
                    className="save"
                    variant="outline-secondary"
                    onClick={handleSubmit}
                  >
                    {isLoading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> :
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="alert alert-warning text-center" role="alert">
            <strong>Form is suspended</strong>
          </div>
        </div>
      }
      <Footer />
    </>
  );
}

export default AddArea;
